import { api } from '@/fsd/shared/api';
import { makeAutoObservable, observable } from 'mobx';

class PurchaseStore {
  fields = {
    meta: {},
    data: [],
  };
  orderDetail = {};
  isTopErrorPurchaseNotificationShown: boolean = false;

  constructor() {
    makeAutoObservable(this, {
      fields: observable,
    });
  }

  getOrders = async () => {
    try {
      const data = await api.post('/api/v1/purchase/list/');

      this.fields.meta = data['meta'];
      this.fields.data = data['data'];
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error);
    }
  };
}

export const purchaseStore = new PurchaseStore();
